import {inject, Injectable} from '@angular/core';
import {File} from "../../../../../features/pages/telegram-page/types/user-telegram.types";
import {FilesGenerateDocumentApiService} from "./files-generate-document-api.service";
import {GenerateFileTypeName} from "../../../../types/file.types";

@Injectable({
  providedIn: 'root'
})
export class FilesGenerateDocumentService {
  private filesGenerateDocumentApiService: FilesGenerateDocumentApiService = inject(FilesGenerateDocumentApiService);

  public generateMethodMap: Record<GenerateFileTypeName, (documentId: number) => Promise<File>> = {
    'CONTRACT': (id) => this.generateContract(id),
    'ACT': (id) => this.generateAct(id),
    'TASK': (id) => this.generateTechTask(id)
  };

  private async generateTechTask(id: number): Promise<File> {
    return new Promise((resolve, reject) => {
      this.filesGenerateDocumentApiService.generateTechTask(id).subscribe({
        next: (file: File) => resolve(file),
        error: (error) => reject(error)
      });
    });
  }

  private async generateAct(id: number): Promise<File> {
    return new Promise((resolve, reject) => {
      this.filesGenerateDocumentApiService.generateAct(id).subscribe({
        next: (file: File) => resolve(file),
        error: (error) => reject(error)
      });
    });
  }

  private async generateContract(id: number): Promise<File> {
    return new Promise((resolve, reject) => {
      this.filesGenerateDocumentApiService.generateContract(id).subscribe({
        next: (file: File) => resolve(file),
        error: (error) => reject(error)
      });
    });
  }
}
